import { HttpClientModule } from '@angular/common/http';
import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app.routing';
import { NgbNavModule, NgbModalModule, NgbDropdownModule, NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { IndexComponent } from './components/index/index.component';
import { SignInFormComponent } from './components/signin/form/sign-in-form.component';
import { SignInComponent } from './components/signin/sign-in.component';
import { FooterComponent } from './components/footer/footer.component';
import { TimerComponent } from './components/tools/timer/timer.component';
import { MaterialInputComponent } from './components/tools/materialInput/material-input.component';
import { MaterialLoaderComponent } from './components/tools/material-loader.component';
import { SignedOutComponent } from './components/signout/signed-out.component';
import { ParamsGuardService } from './providers/params-guard.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UserfulLinksComponent } from './components/signin/useful-links/useful-links.component';
import { CustomDatePickerModule } from './mat-date-picker.module';
import { MatInputModule } from '@angular/material/input';
import { MatSliderModule } from '@angular/material/slider';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { StepsService } from './services/steps.service';
import { ICodeComponent } from './components/i-code/i-code.component';
import { UtilsService } from './services/utils.service';
import { ICodeService } from './services/icode.service';
import { BasicHeaderComponent } from './components/basic-header/basic-header.component';
import { FocusDirective } from './directives/focus';
import { ErrorMsgModalComponent } from './components/error-msg-modal/error-msg-modal.component';
import { PasswordFieldsComponent } from './components/password-fields/password-fields.component';
import { Validator } from '../globals/directives/validator';
import { ChangeCodeComponent } from './components/change-password/change-password-container/change-code/change-code.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ChangePasswordContainerComponent } from './components/change-password/change-password-container/change-password-container.component';
import { LoginHeaderComponent } from './components/login-header/login-header.component';
import { IbankIconComponent } from './components/ibank-icon/ibank-icon.component';
import { LoginComponent } from './components/login/login.component';
import { BrowserCompatibilityComponent } from './components/browser-compatibility/browser-compatibility.component';
import { ManualsComponent } from './components/manuals/manuals.component';
import { GeneralInformationComponent } from './components/general-information/general-information.component';
import { SecurityInformationComponent } from './components/security-information/security-information.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { MetaData } from '../globals/classes/urlBuilder';
import { RegisterUserModalComponent } from './components/register-user-modal/register-user-modal.component';
import { IeWarningModalComponent } from './components/ie-warning-modal/ie-warning-modal.component';
import { AppLanguageModule } from './appLanguage.module';
import { LoadingStageComponent } from './components/loading-stage/loading-stage.component';
import { EmailRestoreContainerComponent } from './components/password-retrieval/email-pass-restore/email-restore-container/email-restore-container.component';
import { EmailPassRestoreComponent } from './components/password-retrieval/email-pass-restore/email-pass-restore.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { UserCodeComponent } from './components/password-retrieval/email-pass-restore/email-restore-container/user-code/user-code.component';
import { RestoreSubmitionComponent } from './components/password-retrieval/initialize-code/restore-submition/restore-submition.component';
import { RestoreValidationComponent } from './components/password-retrieval/initialize-code/restore-validation/restore-validation.component';
import { ValidateCodeComponent } from './components/password-retrieval/email-pass-restore/email-restore-container/validate-code/validate-code.component';
import { CreateNewCodeComponent } from './components/password-retrieval/initialize-code/create-new-code/create-new-code.component';
import { PasswordRetrievalComponent } from './components/password-retrieval/password-retrieval.component';
import { ModalHeaderComponent } from './components/modal-header/modal-header.component';
import { ValidateAuthCodeComponent } from './components/password-retrieval/restore-with-authentication/restore-with-auth-container/validate-auth-code/validate-auth-code.component';
import { RestoreWithAuthenticationComponent } from './components/password-retrieval/restore-with-authentication/restore-with-authentication.component';
import { RestoreWithAuthContainerComponent } from './components/password-retrieval/restore-with-authentication/restore-with-auth-container/restore-with-auth-container.component';
import { CardVerificationComponent } from './components/password-retrieval/restore-with-card/card-verification.component';
import { RestorePasswordWithCardContainerComponent } from './components/password-retrieval/restore-with-card/restore-password-with-card-container.component';
import { RestorePasswordWithCardComponent } from './components/password-retrieval/restore-with-card/restore-password-with-card.component';
import { BasicInfoComponent } from './components/password-retrieval/restore-with-authentication/restore-with-auth-container/basic-info/basic-info.component';
import { CreateCodeComponent } from './components/create-password/create-password-container/create-code/create-code.component';
import { CreatePasswordComponent } from './components/create-password/create-password.component';
import { CreatePasswordContainerComponent } from './components/create-password/create-password-container/create-password-container.component';
import { AgentTypeDirective } from './directives/agentType.directive';
import { FocusAfterViewInit } from './directives/focusAfterViewInit.directive';
import { SignInErrorComponent } from './components/signin/error/sign-in-error.component';
import { UsernameRecoveryModalComponent } from './components/username-recovery-modal/username-recovery-modal.component';
import { ConnectProfileModalComponent } from './components/connect-profile-modal/connect-profile-modal.component';
import { UserConfirmationComponent } from './components/connect-profile-modal/user-confirmation/user-confirmation.component';
import { ProfileConfirmComponent } from './components/connect-profile-modal/profile-confirm/profile-confirm.component';
import { ProfileCompleteComponent } from './components/connect-profile-modal/profile-complete/profile-complete.component';
import { ICodePromptComponent } from '../globals/components/i-code-prompt/i-code-prompt.component';
import { SwitchUsersModalComponent } from './components/switch-users-modal/switch-users-modal.component';
import { CookieComponent } from './components/cookie/cookie.component';
import { IBankCookieService } from '../globals/services/ibank-cookie.service';
import { LinkBlockedComponent } from './components/link-blocked/link-blocked.component';
import { CommonQuestionsComponent } from './components/common-questions/common-questions.component';
import { CommonQuestionsSectionComponent } from './components/common-questions/common-questions-section/common-questions-section.component';
import { CorporateQuestionsSectionComponent } from './components/common-questions/common-questions-section/corporate-questions-section/corporate-questions-section.component';
import { QuestionsSectionComponent } from './components/common-questions/common-questions-section/questions-section/questions-section.component';
import { GeneralQuestionsComponent } from './components/common-questions/general-questions/general-questions.component';
import { GeneralQuestionsItemComponent } from './components/common-questions/general-questions/general-questions-item/general-questions-item.component';
import { DataInfoComponent } from './components/data-info/data-info.component';
import { TwoFAModalComponent } from './components/two-fa-modal/two-fa-modal.component';
import { SwitchComponent } from './components/switch/switch.component';
import { IBankCredentialsModalComponent } from './components/ibank-credentials-modal/ibank-credentials-modal.component';
import { CardDetailsModalComponent } from './components/card-details-modal/card-details-modal.component';
import { CardInfoComponent } from './components/card-info/card-info.component';
import { ConfirmPersonalDetailsModalComponent } from './components/confirm-personal-details-modal/confirm-personal-details-modal.component';
import { ContactInfoModalComponent } from './components/contact-info-modal/contact-info-modal.component';
import { CreatePasswordIntroModalComponent } from './components/create-password-intro-modal/create-password-intro-modal.component';
import { CreateCodeNewComponent } from './components/create-password/create-password-container/create-code-new/create-code-new.component';
import { PasswordValidationComponent } from './components/create-password/create-password-container/create-code-new/password-validation/password-validation.component';
import { CompletePasswordComponent } from './components/complete-password/complete-password.component';
import { ExistingIbankModalComponent } from './components/existing-ibank-modal/existing-ibank-modal.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { CardModalComponent } from './components/card-modal/card-modal.component';
import { ErrorMessageModalComponent } from './components/error-message-modal/error-message-modal.component';
import { SecurityInfoComponent } from './components/security-info/security-info.component';
import { SafeConnectSecurityInfoComponent } from './components/security-info/safe-connect-security-info/safe-connect-security-info.component';
import { SignoutSecurityInfoComponent } from './components/security-info/signout-security-info/signout-security-info.component';
import { SafePasswordSecurityInfoComponent } from './components/security-info/safe-password-security-info/safe-password-security-info.component';
import { MobileSecurityInfoComponent } from './components/security-info/mobile-security-info/mobile-security-info.component';
import { UpdateSecurityInfoComponent } from './components/security-info/update-security-info/update-security-info.component';
import { AntiVirusSecurityInfoComponent } from './components/security-info/anti-virus-security-info/anti-virus-security-info.component';
import { BusinessRegistrationInfoModalComponent } from './components/business-registration-info-modal.component/business-registration-info-modal.component';
import { NewLoginComponent } from './components/new-login/new-login.component';
import { LoginContainerComponent } from './components/login-container/login-container.component';
import { UserTypeSelectionFormComponent } from './components/user-type-selection-form/user-type-selection-form.component';
import { RetailLoginFormComponent } from './components/retail-login-form/retail-login-form.component';
import { BusinessLoginFormComponent } from './components/business-login-form/business-login-form.component';
import { BlockedBusinessModalComponent } from './components/blocked-business-modal/blocked-business-modal.component';
import { ForgetCredentialsRetailModalComponent } from './components/forget-credentials-retail-modal/forget-credentials-retail-modal.component';
import { FaqCategoryComponent } from './components/faqs/faq-category/faq-category.component';
import { FaqCategoryItemComponent } from './components/faqs/faq-category/faq-category-item/faq-category-item.component';
import { FaqsTabContentComponent } from './components/faqs/faqs-tab-content/faqs-tab-content.component';
import { FaqsComponent } from './components/faqs/faqs.component';
import { FaqContainerComponent } from './components/faq-container/faq-container.component';
import { SignInHybridComponent } from './components/sign-in-hybrid/sign-in-hybrid.component';
import { SignInFormHybridComponent } from './components/sign-in-hybrid/form/sign-in-form-hybrid.component';
import { SwitchLoginTransitionModalComponent } from './components/switch-login-transition-modal/switch-login-transition-modal.component';
import { SetPasswordComponent } from './components/set-password/set-password.component';
import { StepperNewComponent } from './components/stepper-new/stepper-new.component';
import { StepperNewInnerComponent } from './components/stepper-new/stepper-new-inner/stepper-new-inner.component';
import { ModalHeaderNewComponent } from './components/modal-header-new/modal-header-new.component';
import { CompletePasswordCreationComponent } from './components/complete-password-creation/complete-password-creation.component';
import { WarningInfoMessageComponent } from './components/warning-info-message/warning-info-message.component';
import { CorporateRecoveryPasswordModalComponent } from './components/corporate-recovery-password-modal/corporate-recovery-password-modal.component';
import { UserCodeCorporateComponent } from './components/user-code-corporate/user-code-corporate.component';
import { LockUserInfoComponent } from './components/lock-user-modal/lock-user-info/lock-user-info.component';
import { LockUserCompleteComponent } from './components/lock-user-modal/lock-user-complete/lock-user-complete.component';
import { LockUserModalComponent } from './components/lock-user-modal/lock-user-modal.component';
import { LockUserWarningModalComponent } from './components/lock-user-warning-modal/lock-user-warning-modal.component';
import { LockUserVerifyComponent } from './components/lock-user-modal/lock-user-verify/lock-user-verify.component';
import { SelfBlockedModalComponent } from './components/self-blocked-modal/self-blocked-modal.component';
import { ClickOutsideDirective } from './directives/clickOutside.directive';
import { ButtonSecondaryComponent } from './components/button-secondary/button-secondary.component';
import { ButtonPrimaryComponent } from './components/button-primary/button-primary.component';
declare const ga: any;

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,
		ReactiveFormsModule,
		HttpClientModule,
		AppRoutingModule,
		NgbNavModule,
		NgbModalModule,
		NgbDropdownModule,
		NgbAccordionModule,
		CustomDatePickerModule,
		MatInputModule,
		MatSliderModule,
		MatSlideToggleModule,
		MatRadioModule,
		MatSelectModule,
		BrowserAnimationsModule,
		AppLanguageModule.forRoot(),
		MatCheckboxModule,
	],
	declarations: [
		MaterialInputComponent,
		TimerComponent,
		MaterialLoaderComponent,
		IndexComponent,
		FooterComponent,
		SignInComponent,
		SignInFormComponent,
		SignedOutComponent,
		UserfulLinksComponent,
		EmailRestoreContainerComponent,
		EmailPassRestoreComponent,
		StepperComponent,
		StepperNewComponent,
		StepperNewInnerComponent,
		UserCodeComponent,
		RestoreSubmitionComponent,
		RestoreValidationComponent,
		ValidateCodeComponent,
		CreateNewCodeComponent,
		UserCodeComponent,
		UserCodeCorporateComponent,
		PasswordRetrievalComponent,
		ICodeComponent,
		ModalHeaderComponent,
		ModalHeaderNewComponent,
		ValidateAuthCodeComponent,
		RestoreWithAuthenticationComponent,
		RestoreWithAuthContainerComponent,
		CardVerificationComponent,
		RestorePasswordWithCardContainerComponent,
		RestorePasswordWithCardComponent,
		BasicInfoComponent,
		BasicHeaderComponent,
		ButtonPrimaryComponent,
		ButtonSecondaryComponent,
		CreateCodeComponent,
		CreatePasswordComponent,
		CreatePasswordContainerComponent,
		RegisterUserModalComponent,
		IeWarningModalComponent,
		FocusDirective,
		ErrorMsgModalComponent,
		ErrorMessageModalComponent,
		PasswordFieldsComponent,
		Validator,
		ChangeCodeComponent,
		ChangePasswordComponent,
		ChangePasswordContainerComponent,
		LoginHeaderComponent,
		IbankIconComponent,
		LoginComponent,
		BrowserCompatibilityComponent,
		ManualsComponent,
		GeneralInformationComponent,
		SecurityInformationComponent,
		SpinnerComponent,
		LoadingStageComponent,
		AgentTypeDirective,
		ClickOutsideDirective,
		FocusAfterViewInit,
		SignInErrorComponent,
		UsernameRecoveryModalComponent,
		ConnectProfileModalComponent,
		ConnectProfileModalComponent,
		UserConfirmationComponent,
		ProfileConfirmComponent,
		ProfileCompleteComponent,
		ICodePromptComponent,
		SwitchUsersModalComponent,
		CookieComponent,
		LinkBlockedComponent,
		CommonQuestionsComponent,
		CommonQuestionsSectionComponent,
		QuestionsSectionComponent,
		CorporateQuestionsSectionComponent,
		DataInfoComponent,
		GeneralQuestionsComponent,
		GeneralQuestionsItemComponent,
		TwoFAModalComponent,
		SwitchComponent,
		IBankCredentialsModalComponent,
		CardDetailsModalComponent,
		CardInfoComponent,
		ConfirmPersonalDetailsModalComponent,
		ContactInfoModalComponent,
		CreatePasswordIntroModalComponent,
		CreateCodeNewComponent,
		PasswordValidationComponent,
		CompletePasswordComponent,
		ExistingIbankModalComponent,
		ResetPasswordComponent,
		CardModalComponent,
		SecurityInfoComponent,
		SafeConnectSecurityInfoComponent,
		SignoutSecurityInfoComponent,
		SafePasswordSecurityInfoComponent,
		MobileSecurityInfoComponent,
		UpdateSecurityInfoComponent,
		AntiVirusSecurityInfoComponent,
		BusinessRegistrationInfoModalComponent,
		NewLoginComponent,
		LoginContainerComponent,
		UserTypeSelectionFormComponent,
		RetailLoginFormComponent,
		BusinessLoginFormComponent,
		BlockedBusinessModalComponent,
		ForgetCredentialsRetailModalComponent,
		FaqCategoryComponent,
		FaqCategoryItemComponent,
		FaqsTabContentComponent,
		FaqsComponent,
		FaqContainerComponent,
		SignInHybridComponent,
		SignInFormHybridComponent,
		SwitchLoginTransitionModalComponent,
		SelfBlockedModalComponent,
		SetPasswordComponent,
		CompletePasswordCreationComponent,
		WarningInfoMessageComponent,
		CorporateRecoveryPasswordModalComponent,
		LockUserInfoComponent,
		LockUserCompleteComponent,
		LockUserModalComponent,
		LockUserWarningModalComponent,
		LockUserVerifyComponent,
	],
	providers: [
		ParamsGuardService,
		StepsService,
		UtilsService,
		ICodeService,
		IBankCookieService,
	],
	bootstrap: [IndexComponent]
})
export class AppModule {
	constructor() {
		// NgbModalConfig is now part of NgbModule, no need to inject separately
	}
}
